module.exports = __webpack_public_path__ + "static/media/ad.ac00227b.png";